import { COLOR_MAP } from '@nile/components';
import React from 'react';
import styled, { css } from 'styled-components';

const FieldTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
`;

const FieldValue = styled.div`
  font-weight: normal;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
`;

const DisabledTag = styled.div`
  opacity: 0.6;
`;

const t = css`
  color: rgba(0, 0, 0, 1);
`;

const t2 = css`
  color: rgba(0, 0, 0, 0.6);
`;

const t3 = css`
  color: rgba(0, 0, 0, 0.4);
`;

const b3 = css`
  font-weight: 500;
`;

const b1 = css`
  font-weight: 700;
`;

const p2 = css`
  font-size: 12px;
`;

const T = styled.div`
  color: rgba(0, 0, 0, 1);
`;
const T1 = styled.div`
  color: rgba(0, 0, 0, 0.8);
`;
const T2 = styled.div`
  color: rgba(0, 0, 0, 0.6);
`;
const T3 = styled.div`
  ${t3}
`;
const T4 = styled.div`
  color: rgba(0, 0, 0, 0.2);
`;

const B1 = styled.div`
  font-weight: bold;
`;

const B3 = styled.div`
  ${b3}
`;

const B3T2 = styled.div`
  ${b3}
  ${t2}
`;

const B1T = styled.div`
  ${b1}
  ${t}
`;

const Text32 = styled.div`
  font-size: 32px;
`;
const H1 = styled.div`
  font-size: 24px;
`;

const H2 = styled.div`
  font-size: 20px;
`;

const H3 = styled.div`
  font-size: 16px;
`;

const P1 = styled.div`
  font-size: 14px;
`;

const P2 = styled.div`
  ${p2}
`;

const P2T2 = styled.div`
  ${p2}
  ${t2}
`;

const NavHeading = styled.div`
  ${t3}
  ${b3}
  ${p2}
`;

const TagWrapper = styled.div`
  background: ${(props) =>
    props.background || 'var(--sops-table-selected-count-bg)'};
  line-height: 16px;
  padding: ${(props) => props.tagSize || props.padding || '8px'};
  border-radius: 4px;
  color: ${(props) => props.color || 'inherit'};
`;

const Tag = (props) => {
  const { active, smooth, danger, children, className, size } = props;
  const sizeMap = { small: '4px 10px' };
  if (active) {
    return (
      <TagWrapper
        background={COLOR_MAP.green}
        color={COLOR_MAP.white}
        tagSize={sizeMap[size]}
        {...props}
      >
        {children}
      </TagWrapper>
    );
  }
  if (danger) {
    return (
      <TagWrapper
        background={COLOR_MAP.red}
        color={COLOR_MAP.white}
        tagSize={sizeMap[size]}
        {...props}
      >
        {children}
      </TagWrapper>
    );
  }
  if (smooth) {
    return (
      <TagWrapper
        background={COLOR_MAP.lightBlue}
        tagSize={sizeMap[size]}
        {...props}
      >
        {children}
      </TagWrapper>
    );
  }
  return (
    <TagWrapper tagSize={sizeMap[size]} {...props}>
      {children}
    </TagWrapper>
  );
};

const NavHeader = (props) => {
  return (
    <NavHeading>
      <span className="uppercase">{props?.children || ''}</span>
    </NavHeading>
  );
};
export {
  FieldTitle,
  FieldValue,
  DisabledTag,
  T,
  T1,
  T2,
  T3,
  T4,
  Tag,
  B1,
  B3,
  H1,
  H2,
  H3,
  Text32,
  NavHeader,
  P1,
  P2,
  B3T2,
  P2T2,
  B1T
};
